import React from 'react';
import { useState, useRef, useEffect, useLayoutEffect } from "react";
import { RadioGroup, FormControlLabel, Radio, Box, Stack, Button, Checkbox } from '@mui/material';
import { useNavigate } from "react-router-dom";
import axios from "../../utils/fvAxios";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { ToastContainer, toast } from "react-toastify";

export default function RenewPrequilification({ Vendid }) {
  const [GetOpenClients, setGetOpenClients] = React.useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    axios.get("Prequalification/GetClientsForRenewal?vendorId=" + Vendid
    ).then((res) => {
      if (res.data.responseCode === 100) {
        setGetOpenClients(res?.data?.data)
      }
      else {
        setError(res.data.responseMessage);
      }
    }).catch(err => {
      console.log(err)
    }).finally(() => {
      setIsLoading(false); // Set isLoading to false after the API call is completed (either success or error)
    });

  }, []);
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const navigate = useNavigate();
  const [selectedClient, setSelectedClient] = useState({});
  const [showRadioGroup, setShowRadioGroup] = useState(true);
  const [copyAnswer, setCopyAnswers] = useState();


  const [isChecked1, setIsChecked1] = useState(false);
  const [isChecked2, setIsChecked2] = useState(false);

  const [selectedData, setSelectedData] = React.useState({});

  const handleChange1 = (selectedObject) => {
    setSelectedData(selectedObject[0]);
    setCopyAnswers(selectedObject[0]?.copyAnswers);

    setIsChecked1(selectedObject[0]?.copyAnswers == 2 ? true : false);
    setIsChecked2(selectedObject[0]?.copyAnswers == 2 ? true : false);
  };



  // Handler for the first checkbox
  const handleCheckbox1Change = (event) => {
    setIsChecked1(event.target.checked);
  };

  // Handler for the second checkbox
  const handleCheckbox2Change = (event) => {
    setIsChecked2(event.target.checked);
  };


  const handleContinueClick = () => {

    if (selectedData?.canForceRenewTemplate == false) {
      setIsLoading(true);
      axios
        .post(
          "Prequalification/CreateRenewalQuestionnaire?vendorId=" + Vendid + "&clientId=" + selectedData?.organizationID + "&isMultiClient=" + selectedData?.isERI + "&copyAns=" + isChecked1 + "&copyDoc=" + isChecked2,
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .then((res) => {
          if (res?.data?.responseMessage == "Success") {
            toast.success(res?.data?.responseMessage, {
              position: "top-right",
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            if (res?.data?.data.errorMessage == "Questionnaire Locked. Redirect to dashboard") { navigate("/DashBoard"); } else { navigate("/vendordetails?pqid=" + res?.data?.data.prequalificationId + "&tab=Questionnaire"); }
            // navigate("/vendordetails?pqid="+res?.data?.data.prequalificationId);
          } else {
            toast.error(res?.data.responseMessage, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });

          }

        })
        .catch((err) => {
          console.log(err);
        }).finally(() => {
          setIsLoading(false); // Set isLoading to false after the API call is completed (either success or error)
        });

    } else {
      setIsLoading(true);
      axios
        .get("Prequalification/GetClientTemplatesForRenewal?clientId=" + selectedData?.organizationID + "&vendorId=" + Vendid + "&isMultiClient=" + selectedData?.isERI)
        .then((res) => {
          if (res?.data?.responseCode == 100) {
            const serializedData = JSON.stringify(res?.data?.data?.templates);
            if (res?.data?.data?.templates?.length > 0) {
              navigate("/TemplatesList?startprq=" + serializedData + "&pqid=" + res?.data?.data?.prequalificationId + "&copyAns=" + isChecked1 + "&copyDoc=" + isChecked2 + "&VendorId=" + Vendid + "&ClientId=" + selectedData?.organizationID + "&IsMultiClient=" + selectedData?.isERI + "&CurrentTempID=" + selectedData?.templateID)
            } else {
              toast.error("No Templates", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });

            }
          } else {
            toast.error(res?.data?.responseMessage, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setIsLoading(false);
        });

    }

  };




  const handleCancleclick = () => {
    navigate(
      "/DashBoard")
  };






  const clientsAboutToExpireEmpty = GetOpenClients?.clientsAboutToExpire?.length === 0;
  const clientsExpiredEmpty = GetOpenClients?.clientsExpired?.length === 0;

  return (
    <>
      <div>
        {isLoading ? <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}

        >
          <CircularProgress color="inherit" />
        </Backdrop> : (
          <Box style={{ backgroundColor: "#fff", padding: "20px", paddingBottom: "30px" }}>
            {clientsAboutToExpireEmpty && clientsExpiredEmpty ? (
              <h2>No Clients available</h2>
            ) : (
              <>
                {/* <RadioGroup name="client" value={selectedClient ? selectedClient.organizationID : null} onChange={handleClientChange}  >
          {!clientsAboutToExpireEmpty && (
              <div>
              <h5 hidden={GetOpenClients?.clientsAboutToExpire?.length==0}>Clients About to Expire</h5>
              {GetOpenClients?.clientsAboutToExpire?.map((client, index) => (
                  <div key={index}>
                    <Stack direction="row" spacing={2}>
                      <Stack spacing={0}>
                        <FormControlLabel
                          value={client.organizationID}
                          control={<Radio />}
                          label={<b style={{ fontSize: "16px" }}>{client.name}</b>}
                        />
                        <span style={{ color: "#3E4A62", fontSize: "16px" }}>
                          {client.address1}, {client.city}, {client.state}, {client.country}
                        </span>
                        <span style={{ color: "#3E4A62", fontSize: "16px" }}>
                          {client.phoneNumber}
                        </span>
                      </Stack>
                      <div style={{ marginLeft: "auto" }}>
                        <Box
                          bgcolor="#f2f2f2"
                          color="#999"
                          p={3}
                          borderRadius={4}
                          textAlign="right"
                          position="relative"
                          ml={2}
                          sx={{ width: "120px", height: "80px" }}
                        >
                          <span>No Logo</span>
                        </Box>
                      </div>
                    </Stack>
                    <br />
                  </div>
                ))}
              </div>
          )}

          {!clientsExpiredEmpty && (
           <div>
           <h5 hidden={GetOpenClients?.clientsExpired?.length==0}>Expired Clients</h5>
organizationID
           {GetOpenClients?.clientsExpired?.map((client, index) => (
               <div key={index}>
                 <Stack direction="row" spacing={2}>
                   <Stack spacing={0}>
                     <FormControlLabel
                       value={client.organizationID}
                       control={<Radio />}
                       label={<b style={{ fontSize: "16px" }}>{client.name}</b>}
                     />
                     <span style={{ color: "#3E4A62", fontSize: "16px" }}>
                       {client.address1}, {client.city}, {client.state}, {client.country}
                     </span>
                     <span style={{ color: "#3E4A62", fontSize: "16px" }}>
                       {client.phoneNumber}
                     </span>
                   </Stack>
                   <div style={{ marginLeft: "auto" }}>
                     <Box
                       bgcolor="#f2f2f2"
                       color="#999"
                       p={3}
                       borderRadius={4}
                       textAlign="right"
                       position="relative"
                       ml={2}
                       sx={{ width: "120px", height: "80px" }}
                     >
                       <span>No Logo</span>
                     </Box>
                   </div>
                 </Stack>
                 <br />
               </div>
             ))}
           </div>
            
          )}
          </RadioGroup> */}
                <>
                  {!clientsAboutToExpireEmpty && (
                    <>
                      <h5>Renew client(s) expiring within 30 days</h5>
                      <RadioGroup name="client" value={selectedData?.organizationID || ''}
                        onChange={(event) => {
                          const selectedName = Number(event.target.value);
                          const selectedObject = GetOpenClients?.clientsAboutToExpire.filter(item => item.organizationID == selectedName) || {};
                          handleChange1(selectedObject);
                        }}>
                        {GetOpenClients?.clientsAboutToExpire?.map((client, index) => (

                          // <FormControlLabel
                          //   key={client.organizationID}
                          //   value={client.organizationID} 
                          //   control={<Radio />}
                          //   label={
                          //     <>
                          //       <b style={{ fontSize: "16px" }}>{client.name}</b>
                          //       <span style={{ color: "#3E4A62", fontSize: "16px" }}>
                          //         {client.address1}, {client.city}, {client.state}, {client.country}
                          //       </span>
                          //       <span style={{ color: "#3E4A62", fontSize: "16px" }}>{client.phoneNumber}</span>
                          //     </>
                          //   }
                          // />
                          <div key={index}>
                            <Stack direction="row" spacing={2}>
                              <Stack spacing={0}>
                                <FormControlLabel
                                  key={client.organizationID}
                                  value={client.organizationID}
                                  control={<Radio />}
                                  label={<b style={{ fontSize: "16px" }}>{client.name}</b>}
                                />
                                <span style={{ color: "#3E4A62", fontSize: "16px" }}>
                                  {client.address1}, {client.city}, {client.state}, {client.country}
                                </span>
                                <span style={{ color: "#3E4A62", fontSize: "16px" }}>
                                  {client.phoneNumber}
                                </span>
                              </Stack>
                              <div style={{ marginLeft: "auto" }}>
                                {/* <Box
                      bgcolor="#f2f2f2"
                      color="#999"
                      p={3}
                      borderRadius={4}
                      textAlign="right"
                      position="relative"
                      ml={2}
                      sx={{ width: "120px", height: "80px" }}
                    >
                      <span>No Logo</span>
                    </Box> */}
                                <img style={{ width: "100px", height: "100px", objectFit: "contain" }} src={"data:image/png;base64," + client?.clientLogoPath} />

                              </div>
                            </Stack>
                            <br />
                          </div>
                        ))}
                      </RadioGroup>
                      {/* for client(s) expiring within 30 days  */}
                      <div hidden={selectedData?.organizationID == null || !clientsExpiredEmpty || copyAnswer != 2}>
                        <FormControlLabel
                          control={<Checkbox checked={isChecked1} onChange={handleCheckbox1Change} />}
                          label="Copy existing questionnaire data to new prequalification (if available)"
                        />
                        <br />
                        <FormControlLabel
                          control={<Checkbox checked={isChecked2} onChange={handleCheckbox2Change} />}
                          label="Copy existing supporting documents to new prequalification (if available)"
                        />
                      </div>
                    </>
                  )}

                  {!clientsExpiredEmpty && (
                    <>
                      <h5>Renew expired client(s)</h5>
                      <RadioGroup name="client" value={selectedData?.organizationID || ''}
                        onChange={(event) => {
                          const selectedName = Number(event.target.value);
                          const selectedObject = GetOpenClients?.clientsExpired?.filter(item => item.organizationID == selectedName) || {};
                          handleChange1(selectedObject);
                        }}>
                        {GetOpenClients?.clientsExpired
                          .map((client, index) => (
                            <div key={index}>
                              <Stack direction="row" spacing={2}>
                                <Stack spacing={0}>
                                  <FormControlLabel
                                    key={client.organizationID}
                                    value={client.organizationID}
                                    control={<Radio />}
                                    label={<b style={{ fontSize: "16px" }}>{client.name}</b>}
                                  />
                                  <span style={{ color: "#3E4A62", fontSize: "16px" }}>
                                    {client.address1}, {client.city}, {client.state}, {client.country}
                                  </span>
                                  <span style={{ color: "#3E4A62", fontSize: "16px" }}>
                                    {client.phoneNumber}
                                  </span>
                                </Stack>
                                <div style={{ marginLeft: "auto" }}>
                                  <img style={{ width: "100px", height: "100px", objectFit: "contain" }} src={"data:image/png;base64," + client?.clientLogoPath} />

                                </div>
                              </Stack>
                              <br />
                            </div>
                          ))}
                      </RadioGroup>
                      <div hidden={selectedData?.organizationID == null || copyAnswer != 2}>
                        <FormControlLabel
                          control={<Checkbox checked={isChecked1} onChange={handleCheckbox1Change} />}
                          label="Copy existing questionnaire data to new prequalification (if available)"
                        />
                        <br />
                        <FormControlLabel
                          control={<Checkbox checked={isChecked2} onChange={handleCheckbox2Change} />}
                          label="Copy existing supporting documents to new prequalification (if available)"
                        />
                      </div>
                    </>
                  )}

                  {clientsAboutToExpireEmpty && clientsExpiredEmpty && <p>No Clients available</p>}
                </>
              </>
            )}


            <div style={{ marginBottom: "20px" }} hidden={clientsAboutToExpireEmpty && clientsExpiredEmpty}>
              <Stack direction="row" spacing={2} style={{ float: "right" }}>
                <Button variant="outlined" sx={{ padding: "15px" }} onClick={handleCancleclick}>Cancel</Button>
                <Button variant="contained" onClick={handleContinueClick} disabled={selectedData.organizationID == null}>Continue --{">"}</Button>
              </Stack>
            </div>



          </Box>
        )}
      </div>
    </>
  )
}
